// src/components/ResetPassword.js
import React, { useMemo, useState } from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ASSISTANT_AUTH_RESET_PASSWORD_URL } from '../constants';

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

const ResetPassword = () => {
  const query = useQuery();
  const token = query.get('token') || '';
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg('');
    setError('');

    if (!token) {
      setError('Enlace inválido o token faltante. Solicita un nuevo enlace de recuperación.');
      return;
    }
    if (!password || !confirm) {
      setError('Por favor completa ambos campos.');
      return;
    }
    if (password !== confirm) {
      setError('Las contraseñas no coinciden.');
      return;
    }
    if (password.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres.');
      return;
    }

    setSubmitting(true);
    try {
      await axios.post(
        ASSISTANT_AUTH_RESET_PASSWORD_URL,
        { token, password },
        { withCredentials: true }
      );
      setMsg('Contraseña actualizada correctamente. Redirigiendo...');
      setTimeout(() => navigate('/admin'), 1500); // 🔹 Redirección a /admin
    } catch (err) {
      const apiMsg = err.response?.data?.msg || 'Token inválido o expirado.';
      setError(apiMsg);
    } finally {
      setSubmitting(false);
    }
  };

  if (!token) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-100">
        <div className="w-full max-w-md p-8 bg-white shadow-md rounded-lg text-center">
          <h2 className="text-2xl font-bold mb-4 text-gray-900">Restablecer contraseña</h2>
          <p className="text-sm text-gray-700 mb-6">
            El enlace de restablecimiento es inválido o ha caducado. Por favor solicita uno nuevo.
          </p>
          <Link to="/recover" className="text-indigo-600 hover:underline">
            Solicitar nuevo enlace
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white shadow-md rounded-lg">
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-900">Establecer nueva contraseña</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Nueva contraseña</label>
            <input
              type="password"
              name="password"
              placeholder="Nueva contraseña"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm
                         focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            />
            <p className="text-xs text-gray-500 mt-1">Mínimo 8 caracteres.</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Confirmar contraseña</label>
            <input
              type="password"
              name="confirm"
              placeholder="Repite la contraseña"
              autoComplete="new-password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm
                         focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            />
          </div>

          {error && <p className="text-red-500 text-sm">{error}</p>}
          {msg && <p className="text-green-600 text-sm">{msg}</p>}

          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-indigo-600 text-white py-2 px-4 rounded-md shadow-sm
                       hover:bg-indigo-700 disabled:opacity-70 focus:outline-none
                       focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            {submitting ? 'Actualizando…' : 'Actualizar contraseña'}
          </button>
        </form>

        <div className="mt-4 text-center">
          <Link to="/login" className="text-sm text-indigo-600 hover:underline">
            Volver al inicio de sesión
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
